import React from 'react';
import cx from 'classnames';
import FaRepeat from 'react-icons/lib/fa/repeat';
import FaPaperPlane from 'react-icons/lib/fa/paper-plane';
import doNotUseAccessibleStaticElementInteractions from 'A11y/doNotUseAccessibleStaticElementInteractions.js';
import { COPY_STRINGS } from '../../constants/translatedCopy';

export default function InstructionRepeatOverlay({ pointerTarget, onReplay, onNext }) {
  const replayLabel = COPY_STRINGS.listening_comprehension_overlay_replay_label;
  const nextLabel = COPY_STRINGS.listening_comprehension_overlay_next_label;
  const replayAria = COPY_STRINGS.listening_comprehension_overlay_replay_aria;
  const nextAria = COPY_STRINGS.listening_comprehension_overlay_next_aria;

  return (
    <div className="replayOverlay modularMultipleChoice__instructionRepeatOverlay">
      <div className="videoPlayerButtonContainer fixedInPlace">
        <div
          className={cx(
            'readAloudButton',
            'replay',
            'clear',
            'pointerTarget',
            'left',
            { showPointer: pointerTarget === 'repeatOverlayReplay' },
          )}
          aria-label={replayAria}
          {...doNotUseAccessibleStaticElementInteractions({ onClick: onReplay })}
        >
          <FaRepeat size="70" className="buttonSvg replay" />
          <div className="buttonLabel replay">{replayLabel}</div>
        </div>
      </div>
      <div className="videoPlayerButtonContainer fixedInPlace">
        <div
          className={cx(
            'readAloudButton',
            'next',
            'clear',
            'pointerTarget',
            'left',
            { showPointer: pointerTarget === 'repeatOverlayNext' },
          )}
          aria-label={nextAria}
          {...doNotUseAccessibleStaticElementInteractions({ onClick: onNext })}
        >
          <FaPaperPlane size="70" className="buttonSvg next" />
          <div className="buttonLabel next">{nextLabel}</div>
        </div>
      </div>
    </div>
  );
}
